import EmailPage from '@portal/features/auth/email'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <EmailPage />
}

export const Route = createFileRoute('/signin/email/')({
  component: RouteComponent,
})
